/**
 * Created by cedricgodefroy on 23/08/2017.
 */
angular.module('FlexyBeautyApp.services').
    factory('ReportDatasSource',["PeriodDatasSource", "EltReportType", "ReportTemporalAgregateFunctionType", "DayData", "ColorGraph", "PrimaryDatasType","moment",
    "PeriodStat","PeriodType","StatPeriodType","Booking", "TaxMode","GiftItem","Customer","BookingService","$log","$filter","ReportTotalAgregateFunctionType","gettextCatalog",

    function(PeriodDatasSource, EltReportType,ReportTemporalAgregateFunctionType,DayData,ColorGraph,PrimaryDatasType,moment,
             PeriodStat,PeriodType,StatPeriodType,Booking,TaxMode,GiftItem,Customer,BookingService, $log, $filter,ReportTotalAgregateFunctionType,gettextCatalog){

        var ReportDatasSource = function(type, prototypeDailyCalculFunction1, prototypeDailyCalculFunction2, temporalAgregateFunctionType, totalAgregateFunctionType, prototypeDailyListeOfPrimaryDatas, rootCategory, currentCategorieId, currentCategorieType, taxMode, typeOfData, typePeriodDataSource, isZeroValueDisplayed, additionalFilters) {
            this.type = type;

            this.prototypeDailyCalculFunction1 = prototypeDailyCalculFunction1;
            this.prototypeDailyCalculFunction2 = prototypeDailyCalculFunction2;
            this.prototypeDailyListeOfPrimaryDatas = prototypeDailyListeOfPrimaryDatas;
            this.temporalAgregateFunctionType = temporalAgregateFunctionType;
            this.totalAgregateFunctionType = totalAgregateFunctionType;

            this.tabStatPeriod = new Array();

            this.currentPeriod = null;
            this.selectedPastPeriod = null;

            this.eltReportDatasSources = new Array();

            this.categorieTable = null;
            this.currentPath = new Array();

            this.rootCategory = rootCategory;
            this.additionalFilters = additionalFilters;
            this.currentCategory = null;

            this.taxMode = taxMode;
            this.typeOfData = typeOfData;
            this.isZeroValueDisplayed = isZeroValueDisplayed?isZeroValueDisplayed:false;

            if(!currentCategorieId){
                currentCategorieId =  this.rootCategory.id;
            }
            this.currentCategorieId = currentCategorieId;
            if(!currentCategorieType){
                currentCategorieType =  this.rootCategory.constructor?this.rootCategory.constructor.name:null;
            }
            this.currentCategorieType = currentCategorieType;

            if(typePeriodDataSource){
                this.typePeriodDataSource = typePeriodDataSource;
            }
            else{
                this.typePeriodDataSource = PeriodDatasSource;
            }

            this.initCurrentPath(this.rootCategory, this.currentCategorieId, this.currentCategorieType);

            if(this.currentPath.length === 0){//currenCategory not found; delete?
                this.currentPath.push(this.rootCategory);
            }

            this.setCurrentCategory(this.currentPath[this.currentPath.length - 1]);

            this.initReportDataSource();
        };

        ReportDatasSource.prototype.initCurrentPath = function(currentCategory, targetCategoryId, targetCategoryType) {
            this.currentPath.push(currentCategory);
            if (currentCategory.id === targetCategoryId && (!currentCategory.constructor || !targetCategoryType || (currentCategory.constructor && targetCategoryType && currentCategory.constructor.name === targetCategoryType))) {
                return true;
            }
            else {
                if(currentCategory.getSubStatCategories){
                    let subCategories = currentCategory.getSubStatCategories(this.rootCategory);
                    let targetFound = false,
                        i = 0;
                    while (!targetFound && i < subCategories.length) {
                        targetFound = this.initCurrentPath(subCategories[i], targetCategoryId, targetCategoryType);
                        i++;
                    }
                    if (!targetFound) {
                         this.currentPath.pop();
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                else {
                     this.currentPath.pop();
                    return false;
                }
            }
        };

        ReportDatasSource.prototype.initReportDataSource = function(){
            this.eltReportDatasSources[EltReportType.TOTALISE.id] = this.getTotaliseDataSource();
            this.eltReportDatasSources[EltReportType.COMPARE.id] = this.getCompareDataSource();
            this.eltReportDatasSources[EltReportType.ZOOM.id] = this.getZoomDataSource();
        };

        ReportDatasSource.prototype.loadPeriod = function(currentPeriod, pastPeriod, taxMode, additionalFilters) {
                this.currentPeriod = currentPeriod;
                this.selectedPastPeriod = pastPeriod;
                if(taxMode){
                    this.taxMode = taxMode;
                }
                if(additionalFilters){
                    this.additionalFilters = additionalFilters;
                }
                this.loadDatas();
        };

        ReportDatasSource.prototype.isLoaded = function (){
            let isLoaded = false;
            if(this.tabStatPeriod[StatPeriodType.CURRENT.id] && this.tabStatPeriod[StatPeriodType.PAST.id]){
                isLoaded = true;
            }
            return isLoaded;
        };

        ReportDatasSource.prototype.loadDatas = function(){
            $log.debug(new moment().format("DD/MM/YYYY HH:mm:ss SSS") + " " + this.type + ": BEGIN calcul current period");
            this.tabStatPeriod[StatPeriodType.CURRENT.id] = this.calculStatByPeriod(this.currentPeriod);
            $log.debug(new moment().format("DD/MM/YYYY HH:mm:ss SSS") + " " + this.type + ": END calcul current period/BEGIN calcul old period");
            this.tabStatPeriod[StatPeriodType.PAST.id] = this.calculStatByPeriod(this.selectedPastPeriod);
            $log.debug(new moment().format("DD/MM/YYYY HH:mm:ss SSS") + " " + this.type + ": END calcul old period ");
            $log.debug("");
            this.initReportDataSource();
        };

        ReportDatasSource.prototype.loadPastPeriod = function(){
            this.tabStatPeriod[StatPeriodType.PAST.id] = this.calculStatByPeriod(this.selectedPastPeriod);
            this.initReportDataSource();
        };

        ReportDatasSource.prototype.getPeriod = function(statPeriodType){
            var period = null;
            if(statPeriodType.id === StatPeriodType.CURRENT.id){
                period = this.currentPeriod;
            }
            else if(statPeriodType.id === StatPeriodType.PAST.id){
                period = this.selectedPastPeriod;
            }
            return period;
        };

        ReportDatasSource.prototype.getPeriodStat = function(statPeriodType){
            if (statPeriodType)
                return this.tabStatPeriod[statPeriodType.id];
        };

        ReportDatasSource.prototype.getCurrentPeriodStat = function(){
            return this.tabStatPeriod[StatPeriodType.CURRENT.id];
        };

        ReportDatasSource.prototype.getPastPeriodStat = function(){
            return this.tabStatPeriod[StatPeriodType.PAST.id];
        };

        ReportDatasSource.prototype.calculStatByPeriod = function(period){
            var periodDataSource = Object.create( this.typePeriodDataSource.prototype );

            // Invoke the custom constructor on the new object,
            // passing in any arguments that were provided.
            this.typePeriodDataSource.apply( periodDataSource, [ this.type,
                period,
                this.prototypeDailyCalculFunction1,
                this.prototypeDailyCalculFunction2,
                this.temporalAgregateFunctionType,
                this.totalAgregateFunctionType,
                this.prototypeDailyListeOfPrimaryDatas,
                this.categorieTable,
                this.currentPath,
                this.taxMode,
                this.typeOfData,
                this.additionalFilters

            ] );

            return periodDataSource;
        };

        ReportDatasSource.prototype.zeroValueDisplayed = function(){
            return (this.isZeroValueDisplayed || (this.prototypeDailyCalculFunction2 || this.totalAgregateFunctionType != ReportTotalAgregateFunctionType.SUM_CATEGORIES ));
        }

        ReportDatasSource.prototype.getTotaliseDataSource = function(){
            var datasChart = new Array(),
                dynamicTitlePart1 = 0,
                sumCategories = 0,
                averageOfCategories = 0;

            if(this.getCurrentPeriodStat()){
                //the tooltip column must be declared before the style column
                //because the style column is usefull and understood only by column chart graph
                datasChart.push(['Type', 'Valeur', {type: 'string', role: 'tooltip', 'p': {'html': true}}, {type: 'string', role: 'style' }]);

                for (var i = 0; i < this.getCurrentPeriodStat().categorieTable.length; i++) {
                    let categoryValue = this.getCurrentPeriodStat().getAgregationOfCategory(this.getCurrentPeriodStat().categorieTable[i]),
                        stat1 = this.getCurrentPeriodStat().stat1ByCategory[this.getCurrentPeriodStat().categorieTable[i].id],
                        stat2 = this.prototypeDailyCalculFunction2?this.getCurrentPeriodStat().stat2ByCategory[this.getCurrentPeriodStat().categorieTable[i].id]:null,
                        totalCategory = this.getCurrentPeriodStat().getAgregationOfTotalCategory(),
                        tooltipValue = null;

                    if(this.typeOfData === "percent" && stat1 && stat2){
                        tooltipValue = "<div style='padding:5px;'><b>" + gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label) + "</b> : " + $filter("smartNumber")(categoryValue, 2) + "% (" + $filter("smartNumber")(stat1,2) + " / " + $filter("smartNumber")(stat2,2) + ") </div>";
                    }
                    else if(this.typeOfData === "percent"){
                        tooltipValue = "<div style='padding:5px;'><b>" + gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label) + "</b> : " + $filter("smartNumber")(categoryValue,2) + "%</div>";
                    }
                    else if(this.typeOfData === "currency" && this.totalAgregateFunctionType === ReportTotalAgregateFunctionType.SUM_CATEGORIES){
                        tooltipValue = "<div style='padding:5px;'><b>" + gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label) + "</b> : " + $filter("currencyFormatFilter")(categoryValue) + " (" + $filter("smartNumber")(categoryValue / totalCategory * 100, 1)  + "%) </div>";
                    }
                    else if(this.typeOfData === "currency"){
                        tooltipValue = "<div style='padding:5px;'><b>" + gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label) + "</b> : " + $filter("currencyFormatFilter")(categoryValue) + "</div>";
                    }
                    else if(this.typeOfData === "time"){
                        tooltipValue = "<div style='padding:5px;'><b>" + gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label) + "</b> : " + $filter("shorterMinutesToTimeString")(categoryValue)+ " </div>";
                    }
                    else if(this.totalAgregateFunctionType === ReportTotalAgregateFunctionType.SUM_CATEGORIES){
                        tooltipValue = "<div style='padding:5px;'><b>" + gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label) + "</b> : " + $filter("smartNumber")(categoryValue) + " (" + $filter("smartNumber")(categoryValue / totalCategory * 100, 1)  + "%) </div>";
                    }
                    else{
                        tooltipValue = "<div style='padding:5px;'><b>" + gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label) + "</b> : " + $filter("smartNumber")(categoryValue,2)+ " </div>";
                    }

                    if( this.zeroValueDisplayed() || (!this.zeroValueDisplayed() &&  categoryValue != 0)){
                    //if(categoryValue > 0) {
                        datasChart.push([gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label), categoryValue, tooltipValue, 'color:' + this.getCurrentPeriodStat().categorieTable[i].color]);
                        sumCategories += categoryValue;
                    }
                }
                dynamicTitlePart1 = this.getCurrentPeriodStat().getAgregationOfTotalCategory();
            }

            return {
                dynamicTitlePart1 : dynamicTitlePart1,
                datasChart : datasChart
            };
        };

        ReportDatasSource.prototype.getCompareDataSource = function() {
            var datasChart = new Array(),
                firstRow = new Array(),
                lastYearRow = new Array(),
                currentYearRow = new Array(),
                dynamicTitlePart1 = 0,
                dynamicTitlePart2 = 0;

            if(this.getCurrentPeriodStat() && this.getPastPeriodStat()) {
                firstRow.push({id: 'Type', label: 'Type', type: 'number'});

                for (var i = 0; i < this.getCurrentPeriodStat().categorieTable.length; i++) {
                    firstRow.push({
                        id: this.getCurrentPeriodStat().categorieTable[i].label,
                        label: gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label),
                        type: 'number'
                    });
                    firstRow.push({type: 'string', role: 'tooltip', 'p': {'html': true}});
                }
                datasChart.push(firstRow);

                lastYearRow.push(1);
                for (var i = 0; i < this.getCurrentPeriodStat().categorieTable.length; i++) {
                    var categoryValue = this.getPastPeriodStat().getAgregationOfCategory(this.getCurrentPeriodStat().categorieTable[i]);
                    lastYearRow.push(categoryValue);
                    lastYearRow.push("<div style='padding:5px'><b>" + this.getCurrentPeriodStat().categorieTable[i].label + "</b></br>Valeur : <b>" + (this.typeOfData == "percent"?($filter('smartNumber')(categoryValue) + "%"): (this.typeOfData == "currency"?($filter('currencyFormatFilter')(categoryValue)):(this.typeOfData == "time"?$filter('shorterMinutesToTimeString')(categoryValue):(this.typeOfData == "number"?$filter('smartNumber')(categoryValue):"")))) +  "</b></div>");
                }
                datasChart.push(lastYearRow);

                currentYearRow.push(2);
                for (var i = 0; i < this.getCurrentPeriodStat().categorieTable.length; i++) {
                    var categoryValue = this.getCurrentPeriodStat().getAgregationOfCategory(this.getCurrentPeriodStat().categorieTable[i]);
                    currentYearRow.push(categoryValue);
                    currentYearRow.push("<div style='padding:5px'><b>" + this.getCurrentPeriodStat().categorieTable[i].label + "</b></br>Valeur : <b>" + (this.typeOfData == "percent"?($filter('smartNumber')(categoryValue) + "%"): (this.typeOfData == "currency"?($filter('currencyFormatFilter')(categoryValue)):(this.typeOfData == "time"?$filter('shorterMinutesToTimeString')(categoryValue):(this.typeOfData == "number"?$filter('smartNumber')(categoryValue):"")))) +  "</b></div>");
                }
                datasChart.push(currentYearRow);

                dynamicTitlePart1 = this.getPastPeriodStat().getAgregationOfTotalCategory();
                dynamicTitlePart2 = this.getCurrentPeriodStat().getAgregationOfTotalCategory();
            }

            return {
                dynamicTitlePart1: dynamicTitlePart1,
                dynamicTitlePart2: dynamicTitlePart2,
                datasChart: datasChart
            };
        };

        ReportDatasSource.prototype.getZoomDataSource = function() {
            var datasChart = new Array(),
                dynamicTitlePart1 = null;

            if(this.getCurrentPeriodStat()) {
                if (this.currentPeriod.periodType === PeriodType.YEAR || (this.currentPeriod.periodType === PeriodType.CUSTOMED && this.currentPeriod.getNbDaysDuration() > 60)) {
                    datasChart = this.getCurrentPeriodStat().getStatByMonth();
                }
                else{
                    datasChart = this.getCurrentPeriodStat().getStatByDay();
                }
                dynamicTitlePart1 = this.getCurrentPeriodStat().getAgregationOfTotalCategory();
            }

            return {
                dynamicTitlePart1: (datasChart.length > 1?  dynamicTitlePart1 : 0),
                datasChart : datasChart
            };
        };

        ReportDatasSource.prototype.getCategoryByLabel = function(label){
            var category = null;
            for(var i = 0; i < this.categorieTable.length;i++){
                if(label == this.categorieTable[i].label){
                    category = this.categorieTable[i];
                    break;
                }
            }
            return category;
        };

        ReportDatasSource.prototype.setCurrentCategory = function(category){
            this.currentCategory = category;
            this.categorieTable = new Array();
            if(category.getSubStatCategories) {
                var subCategory = this.currentCategory.getSubStatCategories(this.rootCategory);

                this.categorieTable = subCategory;
                for (var i = 0; i < this.categorieTable.length; i++) {
                    this.categorieTable[i].color = ColorGraph.colors[i % ColorGraph.colors.length];
                }
            }
        };

        ReportDatasSource.prototype.loadCategory = function(category){
            this.setCurrentCategory(category);
            this.loadDatas();
        };

        ReportDatasSource.prototype.getParentCategory = function() {
            var parent = null;
            if(this.currentPath.length > 1){
                parent = this.currentPath[this.currentPath.length - 2];
            }
            return parent;
        };

        ReportDatasSource.prototype.addCategoryToCurrentPath = function(category) {
            this.currentPath.push(category);
            this.currentCategory = this.currentPath[this.currentPath.length - 1];
        };

        ReportDatasSource.prototype.removeLastCategoryToCurrentPath = function() {
            this.currentPath.pop();
            his.currentCategory = this.currentPath[this.currentPath.length - 1];
        };

        ReportDatasSource.prototype.updatePath = function(category) {
            this.currentPath = this.currentPath.slice(0, this.currentPath.indexOf(category)+1);
            this.currentCategory = this.currentPath[this.currentPath.length - 1];
        };

        ReportDatasSource.prototype.getPrimaryDatasType = function(primaryDataTypePeriodStat) {
            var primaryDatasType = null;
            if(this.tabStatPeriod[primaryDataTypePeriodStat.id] && this.tabStatPeriod[primaryDataTypePeriodStat.id].primaryDatas && this.tabStatPeriod[primaryDataTypePeriodStat.id].primaryDatas.length > 0) {
                primaryDatasType = PrimaryDatasType.getType(this.tabStatPeriod[primaryDataTypePeriodStat.id].primaryDatas[0]);
            }
            return primaryDatasType;
        };

        ReportDatasSource.prototype.getCategoriesOnPeriods = function() {
            var categoriesOnPeriods = this.getCurrentPeriodStat().categorieTable.slice(0);

            for(var i = 0; i < this.getPastPeriodStat().categorieTable.length; i++){
                if(this.getCurrentPeriodStat().categorieTable.indexOf(this.getPastPeriodStat().categorieTable[i]) == -1){
                    categoriesOnPeriods.push(this.getPastPeriodStat().categorieTable[i]);
                }
            }
            return categoriesOnPeriods;
        }

        return ReportDatasSource;
    }]);



// WEBPACK FOOTER //
// ./js/services/views/statistics/report/ReportDatasSource.js